// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__12-Hq","wrapperLang":"styles_wrapperLang__3xrci","item":"styles_item__1CRHD","active":"styles_active__1x7ET","eyeless":"styles_eyeless__2uISV"};